'use strict';
const angular = require('angular');

export class calendarWidgetComponent {

  constructor($uibModal, CalendarEventService, Auth, dialogs, SpeakerService, MeetingService, IntegrationService) {
    'ngInject';

    this.$uibModal = $uibModal;
    this.CalendarEventService = CalendarEventService;
    this.Auth = Auth;
    this.dialogs = dialogs;

    this.eventSources =  [];
    var eventSource = {
      events: []
    };


    this.display = {
      "bob": true,
      "group": true,
      "speakers": true,
      "oneonones": true
    };

    this.data = {
      bob: [],
      group: [],
      speakers: [],
      oneonones: []
    };

    this.filteredData = {
      bob: [],
      group: [],
      speakers: [],
      oneonones: []
    };

    this.type = "group";


    var eventSourceGroup = {
      events: [],
      color: '#228B22',
      textColor: 'white'
    };

    var eventSourceBob = {
      events: [],
      color: '#446e9b',
      textColor: 'white'
    };

    var eventSourceOneOnOnes = {
      events: [],
      color: '#d9534f',
      textColor: 'white'
    };

    var eventSourceSpeakers = {
      events: [],
      color: '#DAA520',
      textColor: 'white'
    };


    this.eventSources.push(eventSourceBob);
    this.eventSources.push(eventSourceGroup);
    this.eventSources.push(eventSourceSpeakers);
    this.eventSources.push(eventSourceOneOnOnes);

    var that = this;

    let resCount = 0;
    let maxResCount = 4;

    let getData = _ => {

      SpeakerService.query(data => {

        data.forEach(speaker => {

          let userName = (speaker.meta.creationUser) ? speaker.meta.creationUser.firstName + ' ' + speaker.meta.creationUser.lastName : "Former Member";
          let userCompany = (speaker.meta.creationUser) ? speaker.meta.companyName : "Former Member";

          this.data.speakers.push({
            title: userName,
            description: userCompany,
            start: moment(speaker.date),
            end: '',
            allDay: true,
            type: 'speaker',
            _id: speaker._id
          });
        });

        resCount++;
        if (resCount == maxResCount)
          this.filterData();
      });

      MeetingService.getByUser({userId: Auth.getCurrentUserSync()._id}, data => {

        data.forEach(meeting => {

          let userName = (meeting.with) ? meeting.with.firstName + ' ' + meeting.with.lastName : "Former Member";

          this.data.oneonones.push({
            title: userName,
            description: meeting.notes,
            start: moment(meeting.date),
            end: '',
            allDay: true
          });
        });

        resCount++;
        if (resCount == maxResCount)
          this.filterData();
      });

      IntegrationService.getCalendarByType({type: 'bob'}, data => {

        data.forEach(evt => {

          var event = evt;

          event.orig = {
            start: event.start,
            end: event.end
          };

          if (event.isRecurring) {
            event.range = {start: event.start, end: event.recurrence.until};

            event.start = moment(event.start).format("HH:mm");

            if (event.end)
              event.end = moment(event.end).format("HH:mm");

            event.dow = event.recurrence.dayOfWeek;
            event.id = event._id;
          }

          that.data.bob.push(event);
        });

        resCount++;
        if (resCount == maxResCount)
          this.filterData();

      }, err => {
        console.log('could not retrieve events from server');
      });

      CalendarEventService.getByType({type: 'group'}, data => {

        data.forEach(evt => {

          var event = evt;

          event.orig = {
            start: event.start,
            end: event.end
          };

          if (event.isRecurring) {
            event.range = {start: event.start, end: event.recurrence.until};

            event.start = moment(event.start).format("HH:mm");

            if (event.end)
              event.end = moment(event.end).format("HH:mm");

            event.dow = event.recurrence.dayOfWeek;
            event.id = event._id;
          }

          that.data.group.push(event);
        });

        resCount++;
        if (resCount == maxResCount)
          this.filterData();

      }, err => {
        console.log('could not retrieve events from server');
      });
    };

    this.getData = getData;
    getData();

    this.filterData = _ => {
      this.filteredData.bob = this.data.bob;
      this.filteredData.group = this.data.group;
      this.filteredData.speakers = this.data.speakers;
      this.filteredData.oneonones = this.data.oneonones;

      if (!this.display.bob)
        this.filteredData.bob = [];
      if (!this.display.group)
        this.filteredData.group = [];
      if (!this.display.speakers)
        this.filteredData.speakers = [];
      if (!this.display.oneonones)
        this.filteredData.oneonones = [];

      for (let i=0; i<=3; i++) { // cleanup
        if (this.eventSources.length && this.eventSources[i].events.length) {
          this.eventSources[i].events.splice(0, this.eventSources[i].events.length);
        }
      }

      this.filteredData.oneonones.forEach(event => {
        this.eventSources[3].events.push(event);
      });

      this.filteredData.speakers.forEach(event => {
        this.eventSources[2].events.push(event);
      });

      this.filteredData.group.forEach(event => {
        this.eventSources[1].events.push(event);
      });

      this.filteredData.bob.forEach(event => {
        this.eventSources[0].events.push(event);
      });

      this.$timeout(() => {
        jQuery('#fullCalendar').fullCalendar('removeEvents');
        this.eventSources.forEach(eventSource => {
          jQuery('#fullCalendar').fullCalendar('addEventSource', eventSource);
        });
      },0);
    };

    this.uiConfig = {
      calendar: {
        timezone: 'local',
        editable: true,
        defaultView: 'listWeek',
        header: {
          left: '',
          center: '',
          right: ''
        },
        eventRender: (event, el) => {
          // Recurring Events
          if (event.isRecurring) {
            if (!(event.start.isBefore(event.range.end) && event.start.isAfter(event.range.start)))
              return false;
          }
        },
        eventClick: (calendarEvent, jsEvent, view) => {

          if (this.public) {
            this.dialogs.notify("Event Details","Event details are only visible when logged in");
            return;
          }

          var that = this;

          var modalInstance = this.$uibModal.open({
            animation: true,
            component: 'calendarEventDetail',
            resolve: {
              calendarEvent: function () {
                return calendarEvent;
              },
              config: function () {
                return {
                  userHasPermission: that.Auth.isAdminSync()
                  || (that.Auth.getCurrentUserSync()._id === calendarEvent.meta.creationUser)
                }
              }
            }
          });

          modalInstance.result.then(
            function (result) {

              if (result.action === 'removed') {
                that.$timeout(() => {
                  that.getData();
                }, 0);
              }

            },
            function () {
            }
          );

        }
      }
    };

  }

  $onInit() {
    /*
    let METHOD = this.public ? "getPublicUpcoming": "getUpcoming";

    this.CalendarEventService[METHOD]({count: this.count || 25}, data => {
      data.forEach(evt => {

        var event = evt;

        event.orig = {
          start: event.start,
          end: event.end
        };

        if (event.isRecurring) {
          event.range = {start: event.start, end: event.recurrence.until};

          event.start = moment(event.start).format("HH:mm");

          if (event.end)
            event.end = moment(event.end).format("HH:mm");

          event.dow = event.recurrence.dayOfWeek;
          event.id = event._id;
        }

        this.eventSources[0].events.push(event);
      });
    }, err => {
      console.log('could not retrieve newest events');
    }) ;
    */
  }
}

export default angular.module('conduuApp.calendarWidget', [])
  .component('calendarWidget', {
    template: `<div id="fullCalendarMain" ui-calendar="$ctrl.uiConfig.calendar" class="span8 calendar" ng-model="$ctrl.eventSources"></div>`,
    bindings: {
     count: '@',
     public: '<'
    },
    controller: calendarWidgetComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/sidebar/calendar-widget/calendar-widget.component.js